import { AxiosResponse } from "axios";
import { GUID } from "../app/common/helper/Guid";
import IArborApplication, { IArborApplicationCreateRequest, IArborApplicationCredentialUpdateRequest, IArborApplicationMetadataUpdateRequest } from "../models/ArborApplication";
import BaseService from "./BaseService";

export default class ArborApplicationService extends BaseService {
    controllerName = "arbor";

    private throwIfRequestFailed(response: unknown): void {
        if (response instanceof Error) {
            throw response;
        }

        if (typeof response === "object" && response !== null) {
            const responseDetails = response as { isAxiosError?: unknown };
            if (responseDetails.isAxiosError === true || "response" in response) {
                throw response;
            }
        }
    }

    private hasResponseData<T>(response: unknown): response is Pick<AxiosResponse<T>, "data"> {
        return typeof response === "object" && response !== null && "data" in response;
    }

    async GetApplications(): Promise<IArborApplication[]> {
        const response: unknown = await this.Get("applications", {});
        if (this.hasResponseData<IArborApplication[]>(response) && Array.isArray(response.data)) {
            return response.data;
        }

        throw response;
    }

    async GetApplication(applicationId: GUID): Promise<IArborApplication | null> {
        const response: unknown = await this.Get(`applications/${applicationId}`, {});
        return this.hasResponseData<IArborApplication | null>(response) ? response.data ?? null : null;
    }

    async CreateApplication(request: IArborApplicationCreateRequest): Promise<void> {
        const response: unknown = await this.Post("applications", request);
        this.throwIfRequestFailed(response);
    }

    async UpdateApplicationMetadata(applicationId: GUID, request: IArborApplicationMetadataUpdateRequest): Promise<void> {
        const response: unknown = await this.Put(`applications/${applicationId}`, request);
        this.throwIfRequestFailed(response);
    }

    async UpdateApplicationCredential(applicationId: GUID, request: IArborApplicationCredentialUpdateRequest): Promise<void> {
        const response: unknown = await this.Patch(`applications/${applicationId}`, request);
        this.throwIfRequestFailed(response);
    }

    async DeleteApplication(applicationId: GUID): Promise<void> {
        const response: unknown = await this.Delete(`applications/${applicationId}`);
        this.throwIfRequestFailed(response);
    }
}